import { TimelineData, TimelineDataSchema, TimelineItem, ValidationResult } from '@/features/timeline/model/schema';
import { z } from 'zod';

const compareItems = (a: TimelineItem, b: TimelineItem): number => {
  const byStart = new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
  if (byStart !== 0) {
    return byStart;
  }
  const aEnd = a.endDate ? new Date(a.endDate).getTime() : Number.POSITIVE_INFINITY;
  const bEnd = b.endDate ? new Date(b.endDate).getTime() : Number.POSITIVE_INFINITY;
  const byEnd = aEnd - bEnd;
  if (byEnd !== 0) {
    return byEnd;
  }
  return a.id.localeCompare(b.id);
};

const normalizeTimelineData = (data: TimelineData): TimelineData => {
  return {
    ...data,
    pages: data.pages.map((page) => ({
      ...page,
      sections: page.sections.map((section) => ({
        ...section,
        items: [...section.items].sort(compareItems),
      })),
    })),
  };
};

export class TimelineValidator {
  static validate(data: unknown): ValidationResult<TimelineData> {
    if (data && typeof data === 'object' && 'timeline' in (data as Record<string, unknown>)) {
      return {
        valid: false,
        errors: [{
          path: 'timeline',
          message: 'このJSON形式は非対応です。pages配列を含むv2形式を使用してください。',
        }],
      };
    }

    try {
      const result = TimelineDataSchema.parse(data);
      const normalized = normalizeTimelineData(result);
      return {
        valid: true,
        data: normalized,
      };
    } catch (error) {
      if (error instanceof z.ZodError) {
        return {
          valid: false,
          errors: error.errors.map((e) => ({
            path: e.path.join('/'),
            message: e.message,
          })),
        };
      }
      return {
        valid: false,
        errors: [
          {
            path: '',
            message: error instanceof Error ? error.message : 'Unknown validation error',
          },
        ],
      };
    }
  }
}
